"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderlineIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000' : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("path", { d: "M16.7263 8.81818V15.4602C16.7263 16.9517 15.7021 18.0256 14.0019 18.0256C12.3016 18.0256 11.2774 16.9517 11.2774 15.4602V8.81818H10.0445V15.5597C10.0445 17.6477 11.6056 19.179 14.0019 19.179C16.3982 19.179 17.9593 17.6477 17.9593 15.5597V8.81818H16.7263Z", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M8.81152 21.7841H19.1922V22.7386H8.81152V21.7841Z", fill: fill }, void 0)] }, void 0));
};
exports.UnderlineIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 28 28' });
//# sourceMappingURL=UnderlineIcon.js.map